import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Bearer fallback: when strict cookie policies block the httpOnly session cookie,
// attach the stored session token so the single-user app still authenticates.
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("session_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const getMeta = () => api.get("/meta").then((r) => r.data);
export const getPortfolio = () => api.get("/portfolio").then((r) => r.data);
export const getIndian = () => api.get("/screener/indian").then((r) => r.data);
export const getGlobal = () => api.get("/screener/global").then((r) => r.data);
export const getProfile = () => api.get("/profile").then((r) => r.data);
export const postAllocator = (body) => api.post("/allocator/plan", body).then((r) => r.data);
export const postRetirement = (body) => api.post("/retirement/forecast", body).then((r) => r.data);
export const postAiBrief = (body) => api.post("/ai/brief", body).then((r) => r.data);
export const getUniverse = () => api.get("/universe").then((r) => r.data);
export const upsertHolding = (body) => api.post("/holdings", body).then((r) => r.data);
export const deleteHolding = (id) => api.delete(`/holdings/${id}`).then((r) => r.data);
export const updateCash = (body) => api.put("/cash", body).then((r) => r.data);
export const setTarget = (id, body) => api.put(`/targets/${id}`, body).then((r) => r.data);
export const addGoal = (body) => api.post("/goals", body).then((r) => r.data);
export const updateGoal = (id, body) => api.put(`/goals/${id}`, body).then((r) => r.data);
export const deleteGoal = (id) => api.delete(`/goals/${id}`).then((r) => r.data);
export const reorderGoals = (order) => api.put("/goals/reorder", { order }).then((r) => r.data);
export const getTriggers = () => api.get("/triggers").then((r) => r.data);
export const postChat = (body) => api.post("/ai/chat", body).then((r) => r.data);
export const getChatHistory = () => api.get("/ai/chat/history").then((r) => r.data);
export const postRecommendations = (body) => api.post("/recommendations", body).then((r) => r.data);
export const getProfile2 = () => api.get("/profile").then((r) => r.data);
export const resetPortfolio = () => api.post("/portfolio/reset").then((r) => r.data);
export const postGoalsPlan = (body) => api.post("/goals/plan", body).then((r) => r.data);
export const updateSettings = (body) => api.put("/settings", body).then((r) => r.data);
export const getScanner = () => api.get("/scanner").then((r) => r.data);
export const refreshScanner = () => api.post("/scanner/refresh").then((r) => r.data);
export const getWatchlist = () => api.get("/watchlist").then((r) => r.data);
export const addWatch = (body) => api.post("/watchlist", body).then((r) => r.data);
export const deleteWatch = (id) => api.delete(`/watchlist/${id}`).then((r) => r.data);
export const getNotifications = () => api.get("/notifications").then((r) => r.data);
export const readNotifications = () => api.post("/notifications/read").then((r) => r.data);
export const updateNotificationSettings = (body) => api.put("/notifications/settings", body).then((r) => r.data);
export const getVapidKey = () => api.get("/push/vapid-key").then((r) => r.data);
export const pushSubscribe = (body) => api.post("/push/subscribe", body).then((r) => r.data);
export const pushTest = () => api.post("/push/test").then((r) => r.data);
export const runAlertsNow = (body) => api.post("/alerts/run-now", body).then((r) => r.data);
export const getTrackRecord = () => api.get("/track-record").then((r) => r.data);
export const searchInstruments = (q) => api.get("/instruments/search", { params: { q } }).then((r) => r.data);
export const addInstrument = (body) => api.post("/instruments", body).then((r) => r.data);
export const getTransactions = (instrument_id) => api.get("/transactions", { params: instrument_id ? { instrument_id } : {} }).then((r) => r.data);
export const addTransaction = (body) => api.post("/transactions", body).then((r) => r.data);
export const deleteTransaction = (id) => api.delete(`/transactions/${id}`).then((r) => r.data);
export const setHoldingGoal = (iid, goal_id) => api.put(`/holdings/${iid}/goal`, { goal_id }).then((r) => r.data);
export const explainPick = (symbol) => api.post("/scanner/explain", { symbol }).then((r) => r.data);
